var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _class, _class2, _descriptor, _descriptor2, _temp;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and set to use loose mode. ' + 'To use proposal-class-properties in spec mode with decorators, wait for ' + 'the next major version of decorators in stage 2.'); }

/*!
 * @copyright
 * Copyright(c) 2019 SICK AG
 */
import { Component, Prop, Interceptor, html, styleMap, nothing } from '@sick-davinci/ce-decorators';
import { style } from './AutoSuggest.style';
import { DropDown } from '../drop-down/DropDown';
/**
 * Auto-suggest is a specialization of the drop-down with auto suggestion.
 * Searches a list for related keywords, phrases, and items, which may match the input string.
 * 
 * @example
 * ```html
 * <davinci-auto-suggest label="Your favorite tree" onchange="console.log(event.detail)"></davinci-auto-suggest>
 * <datalist id="trees">
 *     <option value="Maple"></option>
 *     <option value="Beech"></option>
 *     <option value="Pine"></option>
 *     <option value="Birch"></option>
 *     <option value="Spruce"></option>
 *     <option value="Oak"></option>
 *     <option value="Fir"></option>
 *     <option value="Ash"></option>
 *     <option value="Chestnut"></option>
 * </datalist>
 * ```
 */

export let AutoSuggest = (_dec = Component({
  tag: 'davinci-auto-suggest',
  style,
  inheritStyle: true,
  dependencies: [DropDown]
}), _dec2 = Reflect.metadata("design:paramtypes", []), _dec3 = Prop(), _dec4 = Reflect.metadata("design:type", Number), _dec5 = Prop(), _dec6 = Reflect.metadata("design:type", Boolean), _dec7 = Interceptor('data'), _dec8 = Reflect.metadata("design:paramtypes", [Object, Object]), _dec(_class = _dec2(_class = (_class2 = (_temp = class AutoSuggest extends DropDown {
  /**
   * Specifies the number of letters, that are needed before the suggests will be shown.
   */

  /**
   * Specifies the matcher, that should work case sensitive.
   */
  constructor() {
    super();

    _initializerDefineProperty(this, "minLength", _descriptor, this);

    _initializerDefineProperty(this, "caseSensitive", _descriptor2, this);

    this._isTyping = false;

    this.onInputInput = event => {
      event.preventDefault();
      event.stopPropagation();
      const inputValue = event.currentTarget.value;

      if (inputValue.length >= this.minLength) {
        this.loading = true;
        this._isTyping = true;

        if (this._tempData === undefined) {
          this._tempData = this.data;
        }

        this.data = this._filter(this._tempData);
        this._isTyping = false;
        this.expanded = true;
        this.loading = false;
      } else {
        this.expanded = false;
      }

      this.internalValue = inputValue;
      this.input.emit(this.value);
    };

    this.editable = true;

    this.contentRenderer = (value, label) => html`${this._renderEntry(value, label)}`;
  }

  interceptData(_oldValue, newValue) {
    if (!this._isTyping) {
      this._tempData = newValue;
    }
  }

  _filter(data) {
    return Object.values(data).filter(value => this._compareWithInput(value)); // tslint:disable-line
  }

  _compareWithInput(value) {
    // tslint:disable-line
    if (typeof value === 'object') {
      value = value.value; // tslint:disable-line
    }

    if (this.caseSensitive) {
      if (value.indexOf(this.internalValue) >= 0) {
        // tslint:disable-line
        return value;
      }
    } else {
      if (value.toLowerCase().indexOf(this.internalValue.toLowerCase()) >= 0) {
        // tslint:disable-line
        return value;
      }
    }
  }

  _renderEntry(value, label) {
    if (this.internalValue) {
      const startIndex = label.toLowerCase().indexOf(this.internalValue.toLowerCase());
      const endIndex = startIndex + this.internalValue.length;

      if (startIndex >= 0) {
        // Workaround: Use comments for removing spacing between <spans>
        return html`
          <span>${label.substring(0, startIndex)}</span><!--
          --><span style="${styleMap({
          color: '#323c43'
        })}">${label.substring(startIndex, endIndex)}</span><!--
          --><span>${label.substring(endIndex, label.length)}</span>
        `;
      } else {
        return nothing;
      }
    } else {
      return html`<span>${label ? label : value}</span>`;
    }
  }

}, _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "minLength", [_dec3, _dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 1;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "caseSensitive", [_dec5, _dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class2.prototype, "interceptData", [_dec7, _dec8], Object.getOwnPropertyDescriptor(_class2.prototype, "interceptData"), _class2.prototype)), _class2)) || _class) || _class);
//# sourceMappingURL=AutoSuggest.js.map